export default {"src":"/_next/static/media/card-general.fc1fd746.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};